import { FC } from 'react';

import { Svg, SvgPath, SvgText, addWithConfig } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

type LoyaltyPointsMedalProps = {
  points: number;
  size?: string | number;
};

const LoyaltyPointsMedal: FC<LoyaltyPointsMedalProps> = ({ points, size = 160 }) => (
  <Svg width={size} height={size} viewBox="7 1 61 60">
    <SvgPath
      d="M37.1935 5.62881C35.6957 5.86813 35.7755 3.62626 37.6835 3.48047C39.5365 3.585 38.5343 5.51053 37.1935 5.62881Z"
      fill="#502314"
    />
    <SvgPath
      d="M29.9921 60.5541C-0.971979 55.7909 2.03237 10.4333 29.4228 2.71638C35.0688 1.35456 38.2474 0.235725 47.7797 2.71637C65.2555 7.26419 68.514 28.2102 66.8436 36.3589C62.0467 59.7591 50.4886 61.3214 29.9921 60.5541Z"
      fill="#FFAA00"
    />
    <SvgPath
      d="M32.1436 12.3471C13.5228 17.6834 11.7935 47.968 32.8493 51.2618C46.7861 51.7924 54.3489 51.7924 57.6012 35.611C58.7337 29.9761 57.8818 17.5375 44.5009 11.4054C38.1429 10.6693 35.9821 11.4054 32.1436 12.3471Z"
      fill="#502314"
    />
    <SvgPath
      d="M32.5848 52.3386C10.3909 48.8669 12.2136 16.9452 31.8411 11.3205C35.887 10.3279 38.1646 9.55202 44.8663 10.3279C58.9705 16.7914 59.8684 29.9024 58.6747 35.8419C55.2466 52.8979 47.275 52.8979 32.5848 52.3386ZM17.7645 32.9387C17.8838 46.6673 27.346 50.8281 39.0217 51.2062C50.6914 52.3386 55.3343 44.1602 56.404 35.6555C60.6509 1.66475 17.6084 5.7563 17.7645 32.9387Z"
      fill="#502314"
    />
    <SvgPath
      d="M37.1935 5.62881C35.6957 5.86813 35.7755 3.62626 37.6835 3.48047C39.5365 3.585 38.5343 5.51053 37.1935 5.62881Z"
      fill="#502314"
    />
    <SvgPath
      d="M10.7364 29.9347C10.4968 28.4383 12.7408 28.518 12.8867 30.4243C12.7821 32.2755 10.8548 31.2743 10.7364 29.9347Z"
      fill="#502314"
    />
    <SvgPath
      d="M54.9542 47.3414C55.844 46.114 57.3742 47.7557 56.1282 49.2067C54.744 50.4418 54.0898 48.3723 54.9542 47.3414Z"
      fill="#502314"
    />
    <SvgPath
      d="M61.0753 28.7476C61.9651 27.5203 63.4953 29.1619 62.2493 30.613C60.8651 31.8481 60.2109 29.7785 61.0753 28.7476Z"
      fill="#502314"
    />
    <SvgPath
      d="M18.716 11.1422C19.6057 9.91482 21.1359 11.5565 19.8899 13.0075C18.5057 14.2426 17.8515 12.173 18.716 11.1422Z"
      fill="#502314"
    />
    <SvgPath
      d="M20.2258 47.6751C21.4542 48.564 19.8111 50.0928 18.3587 48.848C17.1224 47.465 19.1939 46.8115 20.2258 47.6751Z"
      fill="#502314"
    />
    <SvgPath
      d="M56.4601 11.4681C57.6886 12.357 56.0454 13.8858 54.5931 12.641C53.3568 11.258 55.4283 10.6045 56.4601 11.4681Z"
      fill="#502314"
    />
    <SvgPath
      d="M18.8666 26.2521C18.4807 24.4597 20.3083 23.0007 21.9595 23.7832L28.7226 26.9884C29.7528 27.4766 30.9836 27.0954 31.5611 26.1092L35.5868 19.2353C36.4472 17.7661 38.5687 17.7848 39.4033 19.2689L43.3076 26.2117C43.8563 27.1877 45.0449 27.5972 46.0747 27.1651L53.4938 24.0513C55.1408 23.3601 56.8794 24.8205 56.4937 26.5711L53.1988 41.525C52.9757 42.5384 52.0814 43.2595 51.0483 43.2595H24.3062C23.2691 43.2595 22.3725 42.5329 22.1532 41.5148L18.8666 26.2521Z"
      fill="#FFAA00"
    />

    <SvgText
      x="37"
      y="39.5"
      fill={primitive.$bbqBrown}
      textAnchor="middle"
      fontSize={13}
      fontFamily={primitive.fontFamily.$headers}
    >
      {points}
    </SvgText>
  </Svg>
);

export default addWithConfig(LoyaltyPointsMedal);
